import { CSSProperties } from 'react';
import { TabStyles } from '@tableau/widgets';

const Spacing = TabStyles.Spacing!;
const FontColors = TabStyles.Typography!.Color!;

export const errorShortMessageStyle: CSSProperties = {
  color: FontColors.Primary,
  paddingBottom: Spacing.LargeSpace,
  maxHeight: '400px',
  overflowY: 'auto',
  WebkitUserSelect: 'text',
  whiteSpace: 'pre-wrap',
  wordWrap: 'break-word',
};

export const errorDetailsContainer: CSSProperties = {
  border: 'solid',
  borderWidth: '1px',
  borderColor: TabStyles.Colors!.F6!,
  padding: Spacing.DefaultSpace,
  maxHeight: '500px',
  overflowY: 'auto',
  wordWrap: 'break-word',
};

export const defectInvestigationLink = {
  paddingBottom: Spacing.DefaultSpace,
};

export const queryDetailsContainer: CSSProperties = {
  whiteSpace: 'pre-wrap',
  WebkitUserSelect: 'text',
};

export const errorDetailsStyle: CSSProperties = {
  paddingBottom: Spacing.DefaultSpace,
  WebkitUserSelect: 'text',
};

export const copyTextareaStyle = {
  opacity: 0,
  height: '0px',
};

export const goToSupportStyle = {
  textDecoration: 'none',
};

export const copyTextBtnStyle = {
  color: FontColors.Primary,
};

export const actionAreaStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const btnGroupStyle = {
  display: 'flex',
};
